import { useQuery } from "react-query";
import { RelatorioInadimplentesPdfResponse, RelatorioInadimplentesQueryParams } from "../typings";
import { AxiosError } from "axios";
import http from "infra/http";

function useRelatorioInadimplentesPdf(query: RelatorioInadimplentesQueryParams) {
  return useQuery<RelatorioInadimplentesPdfResponse, AxiosError>(
    [`/v1/relatorios/financeiro/inadimplentes/pdf`, query],
    async () => {
      const { data } = await http.get<RelatorioInadimplentesPdfResponse>(
        "/v1/relatorios/financeiro/inadimplentes/pdf",
        {
          params: {...query, cpf: query.cpf?.replace(/\W/g, '')},
        }
      );

      return data;
    },
    {
      enabled: false,
    }
  );
}

export default useRelatorioInadimplentesPdf;
